import { Stepper as OriginalStepper } from 'antd-mobile';
import { withNativeElementWrap } from '../../utils/hoc';
export default withNativeElementWrap(OriginalStepper, ['blur', 'focus'], ['onClick']);
